import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import TackledByPositionPref from "./position-pref/tackled-by-position-pref";

export default class Tackle extends Fragment {
    constructor(tackledBy = []) {
        super();
        if (!Array.isArray(tackledBy)) {
            this.tackledBy = [tackledBy];
        } else {
            this.tackledBy = tackledBy;
        }

        this.code = "TACK";

        this.requiredData = [
            {
                name: "tackledBy",
                type: FragmentDataType.Players,
                maxPlayers: 2,
                appliesToOpponent: () => true,
                displayName: "Tackle by",
                title: (team) => `Tackle By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new TackledByPositionPref(play, this).resolve()
            }
        ];
    }

    getPlayers() {
        return this.tackledBy;
    }

    summarize(summaryContext, stringifier) {
        const message = `to ${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            summaryContext.fieldPosition,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )} (${stringifier.firstInitial(this.getPlayers())}) `;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            tackledBy: this.tackledBy.map((p) => playerReducer(p))
        };
    }
}
